export const FACTSHEET_EXPERIENCE_ENGLISH = {
  "datox.suite.brand": "Datox",
  "datox.suite.home": "Overview",
  "datox.suite.yourSpace": "YOUR REPORTING SPACE",
  "datox.suite.templates": "Templates",
  "datox.suite.refreshes": "Refresh schedules",
  "datox.suite.connections": "Connections",
  "datox.suite.skipContent": "Skip to content",
  "datox.suite.openNavigation": "Open navigation",
  "datox.suite.closeNavigation": "Close navigation",
  "datox.suite.dataSources": "Source files",
  "datox.suite.yourData": "Your data. Your design.",
  "datox.suite.yourDataHint": "Create a clearer picture of every portfolio.",
  "datox.suite.factsheetEyebrow": "A CLEARER VIEW OF YOUR PORTFOLIOS",
  "datox.suite.factsheetHeading": "Make your data tell the story.",
  "datox.suite.factsheetHint": "Create, refine and share portfolio dashboards. Every factsheet starts with data you control.",
  "datox.suite.totalWorkspaces": "Reports",
  "datox.suite.designedDashboards": "With dashboards",
  "datox.suite.needsRefresh": "Ready for a refresh",
  "datox.suite.yourFactsheets": "Your factsheets",
  "datox.suite.factsheetListHint": "Every portfolio. Every reporting period. All in one place.",
  "datox.suite.newFactsheetTitle": "Start something worth sharing.",
  "datox.suite.newFactsheetHint": "Give your factsheet a name and a reporting date. You can define the data and design as you go.",
  "datox.suite.closeCreate": "Close new report form",
  "datox.suite.blankCanvas": "A blank canvas, a clear starting point.",
  "datox.suite.blankHint": "Connect your data, define your categories and shape your first dashboard.",
  "datox.suite.clearFilters": "Clear filters",
  "datox.suite.noMatches": "No factsheets match these filters.",
  "datox.suite.libraryEyebrow": "BUILD ON WHAT WORKS",
  "datox.suite.libraryHeading": "Good reporting starts with good structure.",
  "datox.suite.libraryHint": "Your saved category sets, ready to reuse. Refine a definition once and bring it into your next report.",
  "datox.suite.definition": "Category set",
  "datox.suite.templateEyebrow": "A HEAD START, YOUR WAY",
  "datox.suite.templateHeading": "Start with a proven structure.",
  "datox.suite.templateDescription": "Open a designed report canvas, connect your data and export the result.",
  "datox.suite.portfolioTemplate": "Portfolio factsheet",
  "datox.suite.portfolioTemplateHint": "Performance, allocations and holdings in a familiar portfolio layout, connected to your saved data.",
  "datox.suite.templateOutputs": "Editable report template",
  "datox.suite.useTemplate": "Use this template",
  "datox.suite.orStartBlank": "Prefer a blank canvas?",
  "datox.suite.blankDashboardHint": "Create your own categories and build directly in the dashboard designer.",
  "datox.suite.startBlank": "Start a blank dashboard",
  "datox.suite.details": "Factsheet details",
  "datox.suite.detailsHint": "Manage the dates, portfolios and financial settings behind this factsheet.",
  "datox.suite.reportingDate": "As-of date",
  "datox.suite.createFactsheet": "Create factsheet",
  "datox.suite.chooseCurrency": "Choose currency",
  "datox.suite.startingPoint": "Starting point",
  "datox.suite.fromScratch": "Start from scratch",
  "datox.suite.categorySets": "Saved category sets",
  "datox.suite.noCategorySets": "Category sets will appear here when you create your first factsheet.",
  "datox.suite.factsheetPlaceholder": "For example, Global Equity — September",
  "datox.suite.createError": "We couldn't create the report. Please try again.",
  "datox.suite.ready": "Dashboard ready",
  "datox.suite.noPortfolios": "Add a portfolio to get started",
  "datox.suite.lastUpdated": "Last updated",
  "datox.suite.openFactsheet": "Open factsheet",
  "datox.suite.viewTemplates": "Browse templates",
  "datox.suite.noResultsHint": "Try a different search or clear your filters.",
  "datox.suite.categoryHint": "Decide what belongs in your factsheet. Add fields, choose sources and guide the extraction.",
  "datox.suite.dataStepHint": "Categories, fields and source mappings",
  "datox.suite.dashboardStepHint": "Your portfolio, your point of view",
  "datox.suite.savedDefinition": "Saved category set",
} as const
